/* Filters */
var eventCaptureFilters = angular.module('eventCaptureFilters', []);


// WEBPACK FOOTER //
// ./scripts/filters.js